var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.value && !_vm.showInput
        ? _c(
            "div",
            {
              staticClass: "add-textarea-box row items-center",
              class: _vm.name + "-textarea",
              on: { click: _vm.handleShowInput }
            },
            [
              _c("q-icon", { attrs: { name: "add" } }),
              _c("span", [
                _vm._v(_vm._s(_vm.boxText || _vm.$t("add_textarea")))
              ]),
              _vm._v("\n     \n    "),
              _vm.additionalBoxText
                ? _c(
                    "span",
                    {
                      staticClass: "add-textarea-box__additional-text",
                      on: {
                        click: function($event) {
                          _vm.$emit("clicked")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.additionalBoxText))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      (_vm.value || _vm.showInput) && !_vm.useMarkdown
        ? _c("q-input", {
            attrs: {
              value: _vm.value,
              type: "textarea",
              placeholder: _vm.placeholder || _vm.$t("text"),
              name: _vm.name,
              autofocus: ""
            },
            on: { input: _vm.update, blur: _vm.handleInputBlur }
          })
        : (_vm.value || _vm.showInput) && _vm.useMarkdown
          ? _c("q-editor", {
              ref: "editor",
              staticClass: "q-mt-lg round-borders",
              staticStyle: { overflow: "hidden" },
              attrs: {
                value: _vm.value,
                toolbar: _vm.toolbar,
                "toolbar-bg": "white",
                "toolbar-text-color": "grey-7",
                "toolbar-flat": "",
                autofocus: ""
              },
              on: { blur: _vm.handleInputBlur, input: _vm.update }
            })
          : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }